var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIvoryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1387_2790)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1387_2790",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 19,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2388 -0.240234H0.0234375V14.1113H18.2388V-0.240234Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1387_2790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8026 7.32366L15.4479 8.98729L13.1716 11.2889L10.4071 8.49614L9.13086 9.7866L13.1716 13.8698L18.0004 8.98729L15.0788 6.0332L13.8026 7.32366Z",
    fill: "#6A2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08277 7.42975L11.5424 2.45813L9.11135 0L6.64453 2.49665L9.08277 7.42975Z",
    fill: "#D4AD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6504 8.21254L13.9434 4.88287L12.8458 3.77539L10.6504 8.21254Z",
    fill: "#D4AD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34041 3.81445L4.2832 4.88341L7.45958 8.09751L5.34041 3.81445Z",
    fill: "#D4AD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1249 10.8611L7.86719 12.1328L9.1249 13.4045L10.3826 12.1328L9.1249 10.8611Z",
    fill: "#D4AD89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83336 10.0186L2.81425 8.9882L4.46197 7.31975L3.1857 6.0293L0.261719 8.9882L2.55709 11.3091L3.83336 10.0186Z",
    fill: "#6A2F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85517 8.49609L5.78124 10.5931L3.81445 12.5793L5.09072 13.8698L9.13144 9.78414L7.85517 8.49609Z",
    fill: "#6A2F38"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1387_2790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryLogo);
export default __webpack_public_path__ + "static/media/IvoryLogo.9cb33ca1cfb200fcb98e76657237a73a.svg";
export { ForwardRef as ReactComponent };